<ng-select
  [disabled]="isDisabled"
  [items]="bookings"
  bindLabel="name"
  bindValue="id"
  [(ngModel)]="value"
  [loading]="isLoading$ | async"
  [searchFn]="selectSearch"
  [clearable]="allowClearing"
  (change)="onChangeValue($event)"
  (search)="onSearch($event)"
>
  <ng-template ng-label-tmp ng-option-tmp let-item="item">
    {{ item.description }}
  </ng-template>
</ng-select>
